import { render, staticRenderFns } from "./SimulatorResultsMobile.vue?vue&type=template&id=e484e1fa&"
import script from "./SimulatorResultsMobile.vue?vue&type=script&lang=ts&"
export * from "./SimulatorResultsMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports